import React from "react";
import slu from "../assets/slu-clock-tower.jpg";
import partnerImg from "../assets/partner.png";
import job_fair from "../assets/job_fair.png";
import { useNavigate } from "react-router-dom";

const PartnerCardData = [
  {
    id: "001",
    /*image: slu,*/
    title: "Who We Are",
    content: "Connect with our services throughout USA",
    route: "/who-we-are",
  },
  {
    id: "002",
   /* image: partnerImg, */
    title: "Who We Serve",
    content: "Find out how to connect, partner or volunteer with TWA.",
    route: "/who-we-serve",
  },
  {
    id: "003",
    /*image: job_fair,*/
    title: "How to Support",
    content: "Job Seekers can find programs that can help them.",
    route: "/how-to-support",
  },
  { id: "004",
    title: "Faces of Talent",
    content: "Connect employers",
    route: "/video-platform/regions",
  }
];

export default function PartnerCard() {
  const navigate = useNavigate();

  return (
    <section className="flex flex-wrap justify-center items-center w-full relative gap-4 my-10 p-4">
      {PartnerCardData.map((partner, index) => (
        <div
          key={partner.id}
          onClick={() => {navigate(partner.route)
            window.scrollTo(0, 0);
          }}
          className={`flex flex-col justify-center items-center text-center w-full sm:w-60 h-52 cursor-pointer p-4 transition duration-300 ease-in-out hover:shadow-lg ${
            index % 2 === 0 ? "bg-[#bcbcbc]" : "bg-[#003DA5]"
          }`}
        >
          <h3 className="text-3xl sm:text-3xl text-[#fff] font-bold font-['corporate-s']">
            {partner.title}
          </h3>
        </div>
      ))}
    </section>
  );
}